import { alCambiarDeSesion } from './sesionDePeticiones.js';

// Los cerrojos puestos en la sesión vigente, por componente. Un `Map` y no un `WeakMap` porque hay
// que recorrerlo al cambiar de sesión; se vacía entonces y al destruirse cada componente.
let puestos = new Map();

/**
 * #663 · **El cerrojo de una pantalla mientras espera a la frontera, atado a la SESIÓN.**
 *
 * Es la otra mitad de `preloaderDeLaSesion`. Muchas pantallas ponen un campo suyo a `true` antes de
 * pedir algo —`guardando`, `cargando`, `isSaving`…— y lo vuelven a `false` en el `then`, el `catch`
 * o el `finally` de esa petición. Con ese campo apagan botones, enseñan un reloj o, peor, cortan la
 * siguiente llamada (`if (self.isSaving) return;`). Desde la #663 esas continuaciones **no corren**
 * si la sesión cambia en vuelo —es lo que impide pintar o avisar en la cuenta que entra—, y las
 * rutas son casi todas `keepAlive`: la instancia que conserva el campo puesto es la misma que verá
 * la sesión siguiente, con el botón apagado o el guardado bloqueado para siempre (revisión CODEX
 * del PR #1911, ronda 2, y decisión técnica de Donchurru del 26/10/2026).
 *
 * El campo lo sigue soltando la pantalla por el camino normal, exactamente donde lo soltaba. Lo que
 * se añade es el otro camino: cuando la frontera da lo pendiente por cancelado
 * (`alCambiarDeSesion`, que **no** avisa al renovar el token de la misma sesión), se sueltan los
 * cerrojos que se pusieron en la sesión que acaba, y solo ésos. En ese momento la sesión nueva
 * todavía no ha lanzado nada, así que no hay cerrojo suyo que pisar; y la respuesta vieja que
 * llegue después ya no ejecuta el `false` de nadie, porque la frontera la calla.
 *
 *   cerrojoDeLaSesion(self, 'guardando');      // en vez de `self.guardando = true;`
 *   Modelo.guardar(datos).then(function() { self.guardando = false; });
 *
 * Solo para lo que espera a una petición de la frontera: un campo que no dependa de la sesión —un
 * popup abierto, un modo de edición— no es un cerrojo y no se suelta por cambiar de cuenta.
 *
 * @param vm el dueño del campo: el componente, o un objeto de su `data` (`self.prog`) cuando el
 *   cerrojo vive ahí; ese no se da de baja al destruirse, se suelta con el cambio de sesión
 * @param campo el nombre del campo que hace de cerrojo; se pone a `true` aquí
 */
export default function cerrojoDeLaSesion(vm, campo) {
    vm[campo] = true;
    apuntar(vm, campo, false);
}

/**
 * Lo mismo para el cerrojo que es una CUENTA de peticiones en vuelo (`self.cargandoX++`, y cada
 * una lo baja al terminar): suma una y, si la sesión cambia, vuelve a cero.
 */
export function contarEnLaSesion(vm, campo) {
    vm[campo] = (vm[campo] || 0) + 1;
    apuntar(vm, campo, 0);
}

function apuntar(vm, campo, libre) {
    let campos = puestos.get(vm);
    if (!campos) {
        campos = new Map();
        puestos.set(vm, campos);
        // Un componente destruido no tiene nada que soltar, y el registro no debe retenerlo.
        if (typeof vm.$once === 'function') vm.$once('hook:destroyed', function() { puestos.delete(vm); });
    }
    campos.set(campo, libre);
}

alCambiarDeSesion(function() {
    const deLaQueAcaba = puestos;
    puestos = new Map();
    deLaQueAcaba.forEach(function(campos, vm) {
        campos.forEach(function(libre, campo) { vm[campo] = libre; });
    });
});
